<template>
  <div>
    <Profile v-if="employee && !user" />
    <AdminProfile v-else-if="!employee && user == 'admin'" />
    <div v-else>NO PROFILE</div>
  </div>
</template>

<script>
import Profile from "@/views/Profile/profile";
import AdminProfile from "@/views/admin/adminProfile";
import { mapState } from "vuex";
export default {
  watch: {
    "$route.query.test": {
      handler(v) {
        if (v) {
          window.location.reload();
        }
      },
    },
  },
  components: {
    Profile,
    AdminProfile,
  },
  computed: {
    ...mapState("employee", ["employee", "user"]),
  },
};
</script>

<style>
</style>